import React, { useState } from 'react';
import { Save, User, Bell, Shield, CreditCard, ExternalLink } from 'lucide-react';

const SettingsView = ({ t, lang }) => {
  const [settings, setSettings] = useState({
    notifications: {
      email: true,
      push: false,
      newReco: true,
      invalidation: true,
      weeklyReport: true
    },
    profile: {
      name: '',
      email: ''
    }
  });

  const toggleNotif = (key) => {
    setSettings({
      ...settings,
      notifications: { ...settings.notifications, [key]: !settings.notifications[key] }
    });
  };

  const ToggleSwitch = ({ checked, onChange }) => (
    <div 
      onClick={onChange}
      style={{
        width: 48, height: 26, borderRadius: 13, cursor: 'pointer',
        background: checked ? 'var(--gradient-primary)' : 'var(--bg-elevated)',
        border: '1px solid var(--border-color)',
        position: 'relative', transition: 'all 0.2s'
      }}
    >
      <div style={{
        width: 20, height: 20, borderRadius: '50%', background: 'white',
        position: 'absolute', top: 2, left: checked ? 24 : 2,
        transition: 'left 0.2s', boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
      }} />
    </div>
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
      {/* Profile Section */}
      <div className="history-card">
        <div className="history-header">
          <span className="history-title"><User size={18} style={{ marginRight: 8 }} /> {lang === 'fr' ? 'Profil' : 'Profile'}</span>
        </div>
        <div style={{ padding: 24, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <div>
            <label style={{ display: 'block', fontSize: '0.75rem', color: 'var(--text-muted)', marginBottom: 6 }}>
              {lang === 'fr' ? 'Nom complet' : 'Full name'}
            </label>
            <input 
              type="text"
              placeholder="Jean Dupont"
              value={settings.profile.name}
              onChange={(e) => setSettings({ ...settings, profile: { ...settings.profile, name: e.target.value }})}
              style={{ 
                width: '100%', padding: '12px', background: 'var(--bg-tertiary)', 
                border: '1px solid var(--border-color)', borderRadius: 8, color: 'var(--text-primary)'
              }}
            />
          </div>
          <div>
            <label style={{ display: 'block', fontSize: '0.75rem', color: 'var(--text-muted)', marginBottom: 6 }}>
              Email
            </label>
            <input 
              type="email"
              placeholder="jean@example.com"
              value={settings.profile.email}
              onChange={(e) => setSettings({ ...settings, profile: { ...settings.profile, email: e.target.value }})}
              style={{ 
                width: '100%', padding: '12px', background: 'var(--bg-tertiary)', 
                border: '1px solid var(--border-color)', borderRadius: 8, color: 'var(--text-primary)'
              }}
            />
          </div>
        </div>
      </div>

      {/* Notifications Section */}
      <div className="history-card">
        <div className="history-header">
          <span className="history-title"><Bell size={18} style={{ marginRight: 8 }} /> Notifications</span>
        </div>
        <div style={{ padding: 24 }}>
          {[
            { key: 'email', label: lang === 'fr' ? 'Notifications email' : 'Email notifications' },
            { key: 'push', label: lang === 'fr' ? 'Notifications push' : 'Push notifications' },
            { key: 'newReco', label: lang === 'fr' ? 'Nouvelles recommandations' : 'New recommendations' },
            { key: 'invalidation', label: lang === 'fr' ? 'Invalidations' : 'Invalidations' },
            { key: 'weeklyReport', label: lang === 'fr' ? 'Rapport hebdomadaire' : 'Weekly report' }
          ].map(({ key, label }) => (
            <div key={key} style={{ 
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              padding: '14px 0', borderBottom: '1px solid var(--border-color)'
            }}>
              <span style={{ color: 'var(--text-secondary)' }}>{label}</span>
              <ToggleSwitch checked={settings.notifications[key]} onChange={() => toggleNotif(key)} />
            </div>
          ))}
        </div>
      </div>

      {/* Subscription Section */}
      <div className="history-card">
        <div className="history-header">
          <span className="history-title"><CreditCard size={18} style={{ marginRight: 8 }} /> {lang === 'fr' ? 'Abonnement' : 'Subscription'}</span>
        </div>
        <div style={{ padding: 24 }}>
          <div style={{ 
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            padding: 20, background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)',
            borderRadius: 12, border: '1px solid rgba(102, 126, 234, 0.2)'
          }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
                <span style={{ 
                  padding: '4px 10px', background: 'var(--gradient-primary)', 
                  borderRadius: 6, fontSize: '0.6875rem', fontWeight: 700, color: 'white'
                }}>PRO</span>
                <span style={{ fontWeight: 600 }}>{lang === 'fr' ? 'Plan Mensuel' : 'Monthly Plan'}</span>
              </div>
              <span style={{ fontSize: '0.875rem', color: 'var(--text-tertiary)' }}>
                {lang === 'fr' ? 'Renouvellement le 23 janvier 2025' : 'Renews January 23, 2025'}
              </span>
            </div>
            <button className="btn btn-secondary btn-sm">
              <ExternalLink size={14} /> {lang === 'fr' ? 'Gérer' : 'Manage'}
            </button>
          </div>
        </div>
      </div>

      {/* Save Button */}
      <button className="btn btn-primary" style={{ alignSelf: 'flex-start' }}>
        <Save size={16} /> {lang === 'fr' ? 'Enregistrer les modifications' : 'Save changes'}
      </button>
    </div>
  );
};

export default SettingsView;
